import { Group, Stack, Text } from "@mantine/core";
import FFCLogo from "../../assets/images/logos/ffc-short-logo-upd.png";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaLinkedin,
  FaFacebookSquare,
  FaInstagram,
  // FaTwitterSquare,
} from "react-icons/fa";
import "./SocialMediaLinks.css";
const Footer = () => {
  return (
    <Group
      position="apart"
      sx={(theme) => ({
        width: "100%",
        backgroundColor: theme.colors.ffcBrand[6],
        color: theme.other.textLight,
        padding: "3rem 4rem",
        "@media (min-width: 1400px)": {
          padding: "4rem 6rem",
        },
      })}
    >
      {/* Logo and Copyright Section */}
      <Stack align="flex-start">
        <a href="/" rel="noreferrer">
          {/* Using img instead of Avatar */}
          <img
            src={FFCLogo}
            alt="Family Food Centre Logo"
            style={{
              width: "150px", // Adjust the width to your desired size
              height: "auto", // Maintain aspect ratio
              objectFit: "contain", // Make sure the image scales correctly
            }}
          />
        </a>
        <Text size="lg">
          &#169; {new Date().getFullYear()} Family Food Centre
        </Text>
      </Stack>

      {/* Contact Section */}
      <Stack sx={{ padding: "10px" }}>
        <Group spacing="sm" className="hover-effect">
          <a
            href="tel:41413456"
            style={{
              color: "inherit",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <FaPhoneAlt size={25} />
            <Text size="lg" style={{ color: "inherit", marginLeft: "8px" }}>
              41 41 34 56
            </Text>
          </a>
        </Group>
        <Group spacing="sm" className="hover-effect">
          <a
            href="mailto:hello@family.qa"
            style={{
              color: "inherit",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <FaEnvelope size={25} />
            <Text size="lg" style={{ color: "inherit", marginLeft: "8px" }}>
              hello@family.qa
            </Text>
          </a>
        </Group>

        {/* Social Media Icons */}
        <Group>
          <a
            href="https://qa.linkedin.com/company/familyqatar"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-link"
            style={{
              color: "inherit",
              transition: "transform 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#0072b1";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "inherit";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <FaLinkedin size={25} />
          </a>

          <a
            href="https://www.facebook.com/FamilyQatar/"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-link"
            style={{
              color: "inherit",
              transition: "transform 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1DA1F2"; // Twitter hover color
              e.currentTarget.style.transform = "scale(1.1)"; // Hover effect
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "inherit"; // Reset color
              e.currentTarget.style.transform = "scale(1)"; // Reset scale
            }}
          >
            <FaFacebookSquare size={25} />
          </a>

          <a
            href="https://www.instagram.com/family.qatar/"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-link"
            style={{
              color: "inherit",
              transition: "transform 0.3s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#E1306C";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "inherit";
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <FaInstagram size={25} />
          </a>
          <a
            href="https://x.com/family_qa"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-link"
            style={{
              color: "inherit",
              transition: "transform 0.3s, color 0.3s",
              display: "inline-flex", // Use flexbox for centering
              alignItems: "center",
              justifyContent: "center",
              width: "23px", // Adjust width for the outline
              height: "23px", // Adjust height for the outline
              backgroundColor: "transparent", // Set background to transparent
              border: "2px solid white", // White outline
              borderRadius: "5px", // Slightly rounded corners
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1DA1F2"; // Change text color if needed
              e.currentTarget.style.transform = "scale(1.1)"; // Scale up effect
              const svgPath = e.currentTarget.querySelector("path");
              if (svgPath) {
                svgPath.setAttribute("fill", "#1DA1F2"); // Change SVG fill color
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "inherit"; // Reset text color
              e.currentTarget.style.transform = "scale(1)"; // Reset scale
              const svgPath = e.currentTarget.querySelector("path");
              if (svgPath) {
                svgPath.setAttribute("fill", "white"); // Reset SVG fill color
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              style={{ fill: "white" }} // Initial fill color
            >
              <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
            </svg>
          </a>
        </Group>
      </Stack>

      {/* About Section */}
      <Stack>
        <Text size="lg">About the company</Text>
        <Text color="dimmed" size="sm" sx={{ maxWidth: "23rem" }}>
          Qatar's oldest and most favorite supermarket | Since 1978 Al Nasr | Al
          Kheesa | Old Airport Road | Al Rayyan | Family Mart Serving the realm
          of #Qatar since 1978.
        </Text>
      </Stack>
    </Group>
  );
};

export default Footer;
